import {ProfileOutlined as AntdProfileOutlined} from '@ant-design/icons';

export default function ProfileOutlined(props) {
  return <AntdProfileOutlined {...props} />;
}
